export default __webpack_public_path__ + "static/media/f_videoslides.6aeeccae.svg";